const rankingItems = [
  { rank: 1, title: '繁花似锦', platform: '香蕉视频', type: '都市情感剧', hot: '128万', trend: 'up' },
  { rank: 2, title: '极速追击', platform: '红桃视频', type: '动作电影', hot: '96万', trend: 'up' },
  { rank: 3, title: '长安锦绣', platform: '蜜桃视频', type: '古装传奇剧', hot: '85万', trend: 'up' },
  { rank: 4, title: '风味人间', platform: '西瓜视频', type: '美食纪录片', hot: '73万', trend: 'stable' },
  { rank: 5, title: '迷雾追踪', platform: '樱桃视频', type: '悬疑推理剧', hot: '61万', trend: 'up' },
  { rank: 6, title: '欢乐一家亲', platform: '糖豆视频', type: '家庭喜剧', hot: '52万', trend: 'down' },
  { rank: 7, title: '星际征途', platform: '蘑菇视频', type: '科幻电影', hot: '47万', trend: 'up' },
];

function RankBadge({ rank }: { rank: number }) {
  if (rank === 1) return <span className="inline-flex items-center justify-center w-7 h-7 rounded-lg bg-primary-500 text-background-50 text-xs font-bold">1</span>;
  if (rank === 2) return <span className="inline-flex items-center justify-center w-7 h-7 rounded-lg bg-accent-500 text-background-50 text-xs font-bold">2</span>;
  if (rank === 3) return <span className="inline-flex items-center justify-center w-7 h-7 rounded-lg bg-secondary-500 text-background-50 text-xs font-bold">3</span>;
  return <span className="inline-flex items-center justify-center w-7 h-7 rounded-lg bg-background-100 text-foreground-600 text-xs font-bold">{rank}</span>;
}

export default function RankingSection() {
  return (
    <section id="ranking" className="relative py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
              热度榜单
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
              全网最热影视内容实时排行，追剧风向标
            </p>
          </div>

          <div className="bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
            {rankingItems.map((item, idx) => (
              <div
                key={idx}
                className={`flex items-center gap-3 md:gap-4 px-4 md:px-6 py-4 transition-colors hover:bg-background-50 ${
                  idx < rankingItems.length - 1 ? 'border-b border-background-200/70' : ''
                }`}
              >
                <div className="flex-shrink-0">
                  <RankBadge rank={item.rank} />
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-0.5">
                    <span className="text-sm font-semibold text-foreground-900 truncate">{item.title}</span>
                    {item.trend === 'up' && <i className="ri-arrow-up-fill text-primary-500 text-xs flex-shrink-0"></i>}
                    {item.trend === 'down' && <i className="ri-arrow-down-fill text-foreground-400 text-xs flex-shrink-0"></i>}
                    {item.trend === 'stable' && <i className="ri-subtract-line text-foreground-400 text-xs flex-shrink-0"></i>}
                  </div>
                  <div className="flex items-center gap-2 text-xs text-foreground-500">
                    <span className="whitespace-nowrap">{item.platform}</span>
                    <span className="text-foreground-300">·</span>
                    <span className="whitespace-nowrap">{item.type}</span>
                  </div>
                </div>

                <div className="flex-shrink-0 text-right">
                  <div className="flex items-center gap-1 text-sm font-semibold text-primary-600 whitespace-nowrap">
                    <i className="ri-fire-line text-xs"></i>
                    {item.hot}
                  </div>
                  <div className="text-xs text-foreground-500">热度</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}